import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSnackbarComponent } from '../components/mat-snackbar/mat-snackbar.component';

@Injectable({
    providedIn: 'root',
})
export class SnackBarService {
    constructor(private matSnackBar: MatSnackBar) {}

    public errorSnackBar(description: string, isButton = false, url = '', duration = 4000) {
        this.matSnackBar.openFromComponent(MatSnackbarComponent, MatSnackbarComponent.getErrorConfig(description, isButton, url, duration));
    }

    public successSnackBar(description: string, isButton = false, url = '', duration = 4000) {
        this.matSnackBar.openFromComponent(
            MatSnackbarComponent,
            MatSnackbarComponent.getSuccessConfig(description, isButton, url, duration)
        );
    }

    public infoSnackBar(description: string, isButton = false, url = '', duration = 4000) {
        this.matSnackBar.openFromComponent(
            MatSnackbarComponent,
            MatSnackbarComponent.getInfoConfig(description, isButton, url, duration)
        );
    }

    public warningSnackBar(description: string, isButton = false, url = '', duration = 4000) {
        this.matSnackBar.openFromComponent(
            MatSnackbarComponent,
            MatSnackbarComponent.getWarningConfig(description, isButton, url, duration)
        );
    }
}
